import { HmacMD5 } from '@/lib/crypto/crypto'

export default async (to, from, next, injection) => {
  const vue = injection || window.Vue
  const electionSessionKey = HmacMD5.hash('election')

  vue.$sessionStorage.remove(electionSessionKey)
  next()
}
